import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fd96017"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "aside_box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon-share" }, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("申请推广软件")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon-menu" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "查数据", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("渠道数据")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon-wallet" }, null, -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode("子渠道管理")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu_item_group = _resolveComponent("el-menu-item-group")!
  const _component_el_submenu = _resolveComponent("el-submenu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_menu, {
      "unique-opened": true,
      "default-active": _ctx.routerPath,
      router: "",
      class: "menu_box"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_menu_item, { index: "/apply" }, {
          title: _withCtx(() => [
            _hoisted_3
          ]),
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_el_submenu, { index: "/checkData" }, {
          title: _withCtx(() => [
            _hoisted_4,
            _hoisted_5
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_menu_item_group, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item, { index: "/checkData" }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "/secondary" }, {
          title: _withCtx(() => [
            _hoisted_8
          ]),
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["default-active"])
  ]))
}